import axios from '@/api/axios'

// 服务器代理地址
const BASE_URL = process.env.VUE_APP_BASE_URL

// ================================= 《 管理后台 》

// ================================= 《 自媒体管理 》 

// 油管片库 - 批量导入
export function ytBatchImport(parameter) {
  return axios({
    url: BASE_URL + '/zmt/yt_batch_import',
    method: 'post',
    data: parameter
  })
}

// 油管片库 - 创建/编辑
export function ytDramaSave(parameter) {
  return axios({
    url: BASE_URL + '/zmt/yt_drama_save',
    method: 'post',
    data: parameter
  })
}

// 油管片库 - 列表
export function ytDramaList(parameter) {
  return axios({
    url: BASE_URL + '/zmt/yt_drama_list',
    method: 'get',
    params: parameter
  })
}

// 油管内容 - 创建/编辑
export function ytContentSave(parameter) {
  return axios({
    url: BASE_URL + '/zmt/yt_content_save',
    method: 'post',
    data: parameter
  })
}

// 油管内容 - 删除
export function ytContentDelete(parameter) {
  return axios({
    url: BASE_URL + '/zmt/yt_content_delete',
    method: 'post',
    data: parameter
  })
}

// 油管内容 - 列表
export function ytContentList(parameter) {
  return axios({
    url: BASE_URL + '/zmt/yt_content_list',
    method: 'get',
    params: parameter
  })
}

// 油管任务 - 油管频道检索
export function ytAccountAll(parameter) {
  return axios({
    url: BASE_URL + '/task/yt_account_all',
    method: 'get',
    params: parameter
  })
}

// 油管任务 - 发布到油管
export function ytSendYoutube(parameter) {
  return axios({
    url: BASE_URL + '/task/send_youtube',
    method: 'post',
    data: parameter
  })
}

// 媒资管理——列表
export function ytVideoList(parameter) {
  return axios({
    url: BASE_URL + '/zmt/yt_video_list',
    method: 'get',
    params: parameter
  })
}

// 媒资管理——视频批量上传
export function ytVideoUpload(parameter) {
  return axios({
    url: BASE_URL + '/zmt/yt_video_upload',
    method: 'post',
    data: parameter
  })
}

// 媒资管理——广告标记接口
export function ytMarkAdType(parameter) {
  return axios({
    url: BASE_URL + '/zmt/mark_ad_type',
    method: 'get',
    params: parameter
  })
}

// 媒资管理——从片库导入视频
export function ytVideoExport(parameter) {
  return axios({
    url: BASE_URL + '/zmt/video_export',
    method: 'post',
    data: parameter
  })
}

// 媒资管理——片库详情
export function ytDramaDetail(parameter) {
  return axios({
    url: BASE_URL + '/zmt/yt_drama_detail',
    method: 'get',
    params: parameter
  })
}

// 媒资管理——已存在视频
export function ytExistVideo(parameter) {
  return axios({
    url: BASE_URL + '/zmt/exist_video',
    method: 'get',
    params: parameter
  })
}

// 视频翻译 - 前置检查
export function taskCheck(parameter) {
  return axios({
    url: BASE_URL + '/task/check_task',
    method: 'post',
    data: parameter
  })
}

// 视频翻译 - 创建任务及执行
export function taskSave(parameter) {
  return axios({
    url: BASE_URL + '/task/save',
    method: 'post',
    data: parameter
  })
}

// 视频翻译 - 列表
export function taskList(parameter) {
  return axios({
    url: BASE_URL + '/task/list',
    method: 'get',
    params: parameter
  })
}

// 视频翻译 - 集列表
export function taskEqList(parameter) {
  return axios({
    url: BASE_URL + '/task/eq_list',
    method: 'get',
    params: parameter
  })
}

// 视频翻译 - 集详情
export function taskEqDetail(parameter) {
  return axios({
    url: BASE_URL + '/task/eq_detail',
    method: 'get',
    params: parameter
  })
}

// 视频翻译 - 根据类型获取视频地址
export function taskEqTypeUrl(parameter) {
  return axios({
    url: BASE_URL + '/task/eq_type_url',
    method: 'get',
    params: parameter
  })
}

// 视频翻译 - 集字幕保存
export function taskEqSave(parameter) {
  return axios({
    url: BASE_URL + '/task/eq_save',
    method: 'post',
    data: parameter
  })
}

// 视频翻译 - 同步状态
export function taskSysJob(parameter) {
  return axios({
    url: BASE_URL + '/task/sys_job',
    method: 'get',
    params: parameter
  })
}

// 视频翻译 - 批量同步
export function taskSysTask(parameter) {
  return axios({
    url: BASE_URL + '/task/sys_task',
    method: 'get',
    params: parameter
  })
}

// 视频翻译 - 合并视频
export function taskLongVideo(parameter) {
  return axios({
    url: BASE_URL + '/task/long_video',
    method: 'get',
    params: parameter
  })
}

// 发布账号 - 检索
export function accountAll(parameter) {
  return axios({
    url: BASE_URL + '/zmt/account_all',
    method: 'get',
    params: parameter
  })
}

// 运营账号 - 检索
export function adminAll(parameter) {
  return axios({
    url: BASE_URL + '/zmt/admin_all',
    method: 'get',
    params: parameter
  })
}

// 账号管理 - 创建/编辑
export function accountSave(parameter) {
  return axios({
    url: BASE_URL + '/zmt/account_save',
    method: 'post',
    data: parameter
  })
}

// 账号管理 - 列表
export function accountList(parameter) {
  return axios({
    url: BASE_URL + '/zmt/account_list',
    method: 'get',
    params: parameter
  })
}

// 音色库 - 列表
export function speechList(parameter) {
  return axios({
    url: BASE_URL + '/task/speech_list',
    method: 'get',
    params: parameter
  })
}

// 音色库 - 检索
export function speechAll(parameter) {
  return axios({
    url: BASE_URL + '/task/speech_all',
    method: 'get',
    params: parameter
  })
}

// 音色库 - 编辑/创建
export function speechSave(parameter) {
  return axios({
    url: BASE_URL + '/task/speech_save',
    method: 'post',
    data: parameter
  })
}

// 音色库 - 删除
export function speechDelete(parameter) {
  return axios({
    url: BASE_URL + '/task/speech_delete',
    method: 'post',
    data: parameter
  })
}

// 任务 —— 单任务失败重新翻译
export function taskEqTask(parameter) {
  return axios({
    url: BASE_URL + '/task/eq_task',
    method: 'post',
    data: parameter
  })
}

// 油管片库——音效详情
export function sfxDetail(parameter) {
  return axios({
    url: BASE_URL + '/zmt/sfx_detail',
    method: 'get',
    params: parameter
  })
}

// 油管片库——音效保存
export function sfxSave(parameter) {
  return axios({
    url: BASE_URL + '/zmt/sfx_save',
    method: 'post',
    data: parameter
  })
}

// 任务——下载全集字幕
export function downloadSubtitle(parameter) {
  return axios({
    url: BASE_URL + '/task/download_subtitle',
    method: 'get',
    params: parameter
  })
}

// 任务——汇总列表
export function listAll(parameter) {
  return axios({
    url: BASE_URL + '/task/list_all',
    method: 'get',
    params: parameter
  })
}

// 任务——提交并重新配音
export function taskUpdateSubtitles(parameter) {
  return axios({
    url: BASE_URL + '/task/update_subtitles',
    method: 'post',
    data: parameter
  })
}

// 任务——移除一行字幕
export function taskRemoveSubtitle(parameter) {
  return axios({
    url: BASE_URL + '/task/remove_subtitle',
    method: 'post',
    data: parameter
  })
}

// 任务——新增一行字幕
export function taskCreateSubtitle(parameter) {
  return axios({
    url: BASE_URL + '/task/create_subtitle',
    method: 'post',
    data: parameter
  })
}

// 任务——集字幕-翻译
export function taskTranslateSubtitleText(parameter) {
  return axios({
    url: BASE_URL + '/task/translate_subtitle_text',
    method: 'post',
    data: parameter
  })
}

// ================================= 《 内容管理 》 

// 片库添加
export function dramaAdd(parameter) {
  return axios({
    url: BASE_URL + '/drama/drama_add',
    method: 'post',
    data: parameter
  })
}

// 片库修改
export function dramaEdit(parameter) {
  return axios({
    url: BASE_URL + '/drama/drama_edit',
    method: 'post',
    data: parameter
  })
}

// 片库详情
export function dramaDetail(parameter) {
  return axios({
    url: BASE_URL + '/drama/drama_detail',
    method: 'get',
    params: parameter
  })
}

// 广点通分类列表
export function dramaGdtTypeList(parameter) {
  return axios({
    url: BASE_URL + '/drama/gdt_type_list',
    method: 'get',
    params: parameter
  })
}

// 同步京东图片
export function jdSyncImage(parameter) {
  return axios({
    url: BASE_URL + '/drama/sync_jd_image',
    method: 'post',
    data: parameter
  })
}

// 同步抖音图片
export function ttSyncImage(parameter) {
  return axios({
    url: BASE_URL + '/examine/sync_image',
    method: 'post',
    data: parameter
  })
}

// 同步快手图片
export function ksSyncImage(parameter) {
  return axios({
    url: BASE_URL + '/drama/sync_ks_image',
    method: 'post',
    data: parameter
  })
}

// 京东 - 创建合集
export function jdCeateSyncCollection(parameter) {
  return axios({
    url: BASE_URL + '/drama/sync_jd_collection',
    method: 'post',
    data: parameter
  })
}

// 京东 - 同步视频/绑定合集
export function jdSyncVideo(parameter) {
  return axios({
    url: BASE_URL + '/drama/sync_jd_videos',
    method: 'post',
    data: parameter
  })
}

// 片库列表
export function dramaList(parameter) {
  return axios({
    url: BASE_URL + '/drama/drama_list',
    method: 'get',
    params: parameter
  })
}

// 剧集列表
export function videoList(parameter) {
  return axios({
    url: BASE_URL + '/drama/video_list',
    method: 'get',
    params: parameter
  })
}

// 片库分发
export function dramaDistribute(parameter) {
  return axios({
    url: BASE_URL + '/drama/drama_distribute',
    method: 'post',
    data: parameter
  })
}

// 剧集上传或更换
export function videoUpload(parameter) {
  return axios({
    url: BASE_URL + '/drama/video_upload',
    method: 'post',
    data: parameter
  })
}

// 已存在剧集
export function existVideo(parameter) {
  return axios({
    url: BASE_URL + '/drama/exist_video',
    method: 'get',
    params: parameter
  })
}

// 导出微信上传审核列表
export function exportWechatVideos(parameter) {
  return axios({
    url: BASE_URL + '/drama/export_wechat_videos',
    method: 'get',
    params: parameter
  })
}

// 剧集 - 同步视频
export function syncVideo(parameter) {
  return axios({
    url: BASE_URL + '/drama/sync_video',
    method: 'get',
    params: parameter
  })
}
// 同步媒资
export function videoMedia(parameter) {
  return axios({
    url: BASE_URL + '/drama/sync_video_media',
    method: 'post',
    data: parameter
  })
}

// 通过资源ID更新穿山甲剧集
export function videoMediaCsj(parameter) {
  return axios({
    url: BASE_URL + '/examine/csj_query_drama',
    method: 'post',
    data: parameter
  })
}

// 抖音同步视频
export function ttSyncVideo(parameter) {
  return axios({
    url: BASE_URL + '/examine/sync_video',
    method: 'post',
    data: parameter
  })
}

// 快手同步视频
export function ksSyncVideo(parameter) {
  return axios({
    url: BASE_URL + '/drama/sync_ks_videos',
    method: 'post',
    data: parameter
  })
}

// 快手发布视频
export function ksPushVideo(parameter) {
  return axios({
    url: BASE_URL + '/drama/publish_video',
    method: 'post',
    data: parameter
  })
}

// 设置剧集介绍
export function videoDescription(parameter) {
  return axios({
    url: BASE_URL + '/drama/video_description_set',
    method: 'post',
    data: parameter
  })
}

// 不分页项目列表
export function projectList(parameter) {
  return axios({
    url: BASE_URL + '/drama/project_list',
    method: 'get',
    params: parameter
  })
}

// 分发记录
export function distributeList(parameter) {
  return axios({
    url: BASE_URL + '/drama/drama_distribute_list',
    method: 'get',
    params: parameter
  })
}

// 短剧列表
export function dramaAll(parameter) {
  return axios({
    url: BASE_URL + '/drama/drama_all',
    method: 'get',
    params: parameter
  })
}

// 视频导入
export function videoExport(parameter) {
  return axios({
    url: BASE_URL + '/drama/video_export',
    method: 'post',
    data: parameter
  })
}

// 抖小标签
export function dyTags(parameter) {
  return axios({
    url: BASE_URL + '/drama/dy_tag',
    method: 'get',
    params: parameter
  })
}

// 短剧创建
export function dySyncCreate(parameter) {
  return axios({
    url: BASE_URL + '/examine/sync_create',
    method: 'post',
    data: parameter
  })
}

// 短剧编辑/绑定
export function dySyncEdit(parameter) {
  return axios({
    url: BASE_URL + '/examine/sync_edit',
    method: 'post',
    data: parameter
  })
}

// 短剧送审
export function dyExamineDrama(parameter) {
  return axios({
    url: BASE_URL + '/examine/examine_drama',
    method: 'post',
    data: parameter
  })
}

// 短剧上线
export function dyOnlineDrama(parameter) {
  return axios({
    url: BASE_URL + '/examine/online_drama',
    method: 'post',
    data: parameter
  })
}

// 授权列表
export function dyDramaList(parameter) {
  return axios({
    url: BASE_URL + '/examine/drama_project',
    method: 'get',
    params: parameter
  })
}

// 短剧授权
export function dyAuthDrama(parameter) {
  return axios({
    url: BASE_URL + '/examine/auth_drama',
    method: 'post',
    data: parameter
  })
}

// 授权列表
export function wxDramaList(parameter) {
  return axios({
    url: BASE_URL + '/drama/wx_drama_project',
    method: 'get',
    params: parameter
  })
}

// 短剧授权
export function wxAuthDrama(parameter) {
  return axios({
    url: BASE_URL + '/drama/wx_auth_drama',
    method: 'post',
    data: parameter
  })
}

// 微小 - 编辑信息
export function wxEditDrama(parameter) {
  return axios({
    url: BASE_URL + '/drama/wx_edit_drama',
    method: 'post',
    data: parameter
  })
}

// 快小 - 题材类型
export function ksTags(parameter) {
  return axios({
    url: BASE_URL + '/drama/ks_tag',
    method: 'get',
    params: parameter
  })
}

// 快小 - 片库 — 同步快小 —创建、编辑
export function ksSave(parameter) {
  return axios({
    url: BASE_URL + '/drama/ks_save',
    method: 'post',
    data: parameter
  })
}

// 快小 - 片库 — 同步快小 — 送审
export function ksExamine(parameter) {
  return axios({
    url: BASE_URL + '/drama/ks_examine',
    method: 'post',
    data: parameter
  })
}

// 片库状态列表
export function dramaStatusList(parameter) {
  return axios({
    url: BASE_URL + '/drama/drama_status_list',
    method: 'get',
    params: parameter
  })
}

// 快小 - 片库 — 同步快小 — 上架
export function ksOnline(parameter) {
  return axios({
    url: BASE_URL + '/drama/ks_online',
    method: 'post',
    data: parameter
  })
}

// 快小 - 片库 — 同步快小 — 刷新审核状态
export function ksRefresh(parameter) {
  return axios({
    url: BASE_URL + '/drama/ks_detail',
    method: 'post',
    data: parameter
  })
}

// 快小 - 片库 — 同步快小 — 授权项目列表
export function ksDramaProjectList(parameter) {
  return axios({
    url: BASE_URL + '/drama/ks_drama_project',
    method: 'get',
    params: parameter
  })
}

// 快小 - 片库 — 同步快小 — 授权/取消
export function ksAuthDrama(parameter) {
  return axios({
    url: BASE_URL + '/drama/ks_auth_drama',
    method: 'post',
    data: parameter
  })
}

// 小红书 - 片库 — 同步剧集
export function xhsSyncDrama(parameter) {
  return axios({
    url: BASE_URL + '/drama/sync_xhs_video_media',
    method: 'post',
    data: parameter
  })
}

// 片库状态修改
export function dramaSetStatus(parameter) {
  return axios({
    url: BASE_URL + '/drama/set_drama_status',
    method: 'post',
    data: parameter
  })
}

// 短剧授权
export function dyBindPage(parameter) {
  return axios({
    url: BASE_URL + '/examine/bind_page',
    method: 'post',
    data: parameter
  })
}

// 绑定页面(穿山甲)
export function csjBindPage(parameter) {
  return axios({
    url: BASE_URL + '/examine/csj_bind_page',
    method: 'post',
    data: parameter
  })
}

// 默认付费模版
export function chargePanelAll(parameter) {
  return axios({
    url: BASE_URL + '/reseller/charge_panel_all_new',
    method: 'get',
    params: parameter
  })
}

// 默认付费模版
export function chargeAll(parameter) {
  return axios({
    url: BASE_URL + '/reseller/charge_all_new',
    method: 'get',
    params: parameter
  })
}

// 推荐频道 - 列表
export function recommendList(parameter) {
  return axios({
    url: BASE_URL + '/drama/recommend_list',
    method: 'get',
    params: parameter
  })
}

// 推荐频道 - 新增
export function recommendAdd(parameter) {
  return axios({
    url: BASE_URL + '/drama/recommend_add',
    method: 'post',
    data: parameter
  })
}

// 推荐频道 - 频道删除
export function recommendDelete(parameter) {
  return axios({
    url: BASE_URL + '/drama/recommend_delete',
    method: 'post',
    data: parameter
  })
}

// 推荐频道 - 权重修改
export function recommendWeightSave(parameter) {
  return axios({
    url: BASE_URL + '/drama/recommend_weight_save',
    method: 'post',
    data: parameter
  })
}

// 推荐频道 - 剧集列表
export function recommendVideoEqList(parameter) {
  return axios({
    url: BASE_URL + '/drama/recommend_video_list',
    method: 'get',
    params: parameter
  })
}

// 剧集状态变更日志 - 列表
export function dramaLogList(parameter) {
  return axios({
    url: BASE_URL + '/drama/drama_log_list',
    method: 'get',
    params: parameter
  })
}

// ================================= 《 分销管理（旧） 》

// 二级分销列表
export function distributorAgentList(parameter) {
  return axios({
    url: BASE_URL + '/distributor/agent_list',
    method: 'get',
    params: parameter
  })
}

// 分销商项目列表
export function distributorProjectList(parameter) {
  return axios({
    url: BASE_URL + '/distributor/project_list',
    method: 'get',
    params: parameter
  })
}

// 分销商列表
export function distributorList(parameter) {
  return axios({
    url: BASE_URL + '/distributor/list',
    method: 'get',
    params: parameter
  })
}

// 添加或修改分销商
export function distributorSave(parameter) {
  return axios({
    url: BASE_URL + '/distributor/save',
    method: 'post',
    data: parameter
  })
}

// 分销商详情
export function distributorDetail(parameter) {
  return axios({
    url: BASE_URL + '/distributor/detail',
    method: 'get',
    params: parameter
  })
}

// 每日分销数据
export function distributorTotalDayData(parameter) {
  return axios({
    url: BASE_URL + '/distributor/total_day_data',
    method: 'get',
    params: parameter
  })
}

// 分销商数据
export function distributorData(parameter) {
  return axios({
    url: BASE_URL + '/distributor/distributor_data',
    method: 'get',
    params: parameter
  })
}

// 分销商数据 - 每日数据
export function distributorDayData(parameter) {
  return axios({
    url: BASE_URL + '/distributor/distributor_day_data',
    method: 'get',
    params: parameter
  })
}

// 分销商数据 - 短剧数据
export function distributorDramaData(parameter) {
  return axios({
    url: BASE_URL + '/distributor/drama_data',
    method: 'get',
    params: parameter
  })
}

// 分销结算单
export function distributorCashList(parameter) {
  return axios({
    url: BASE_URL + '/distributor/cash_list',
    method: 'get',
    params: parameter
  })
}

// 完成打款
export function distributorSetCash(parameter) {
  return axios({
    url: BASE_URL + '/distributor/set_cash',
    method: 'post',
    data: parameter
  })
}

// 结算单详情列表
export function distributorCashDetailList(parameter) {
  return axios({
    url: BASE_URL + '/distributor/cash_detail_list',
    method: 'get',
    params: parameter
  })
}

// ===================================《 用户退款 》

// 发起退款
export function refundOrder(parameter) {
  return axios({
    url: BASE_URL + `/order/refund_order`,
    method: 'post',
    data: parameter
  })
}

// 退款
export function refund(parameter) {
  return axios({
    url: BASE_URL + `/order/refund`,
    method: 'post',
    data: parameter
  })
}

// 退款单列表
export function refundList(parameter) {
  return axios({
    url: BASE_URL + `/order/refund_list`,
    method: 'get',
    params: parameter
  })
}

// ================================= 《 分销管理 》 

// 分销商列表
export function resellerList(parameter) {
  return axios({
    url: BASE_URL + `/reseller/reseller_list`,
    method: 'get',
    params: parameter
  })
}

// 分销商详情
export function resellerDetail(parameter) {
  return axios({
    url: BASE_URL + `/reseller/reseller_detail`,
    method: 'get',
    params: parameter
  })
}

// 分销商添加或修改
export function resellerSave(parameter) {
  return axios({
    url: BASE_URL + `/reseller/save`,
    method: 'post',
    data: parameter
  })
}

// 平台列表
export function resellerPlatformList(parameter) {
  return axios({
    url: BASE_URL + `/reseller/platform_list`,
    method: 'get',
    params: parameter
  })
}

// 分销商片库列表
export function resellerDramaList(parameter) {
  return axios({
    url: BASE_URL + `/reseller/reseller_drama_list`,
    method: 'get',
    params: parameter
  })
}

// 片库设置-下载（单个）
export function resellerIsDownload(parameter) {
  return axios({
    url: BASE_URL + `/reseller/is_download`,
    method: 'post',
    data: parameter
  })
}

// 片库设置-可见（单个）
export function resellerIsVisible(parameter) {
  return axios({
    url: BASE_URL + `/reseller/is_visible`,
    method: 'post',
    data: parameter
  })
}

// 片库设置-下载（批量）
export function resellerIsAllDownload(parameter) {
  return axios({
    url: BASE_URL + `/reseller/is_all_download`,
    method: 'post',
    data: parameter
  })
}

// 片库设置-可见（批量）
export function resellerIsAllVisible(parameter) {
  return axios({
    url: BASE_URL + `/reseller/is_all_visible`,
    method: 'post',
    data: parameter
  })
}

// 商务列表（搜索）- 列表
export function resellerBusiness(parameter) {
  return axios({
    url: BASE_URL + `/reseller/business_list`,
    method: 'get',
    params: parameter
  })
}

// 分销商（搜索）- 列表
export function resellerUser(parameter) {
  return axios({
    url: BASE_URL + `/reseller/reseller_user`,
    method: 'get',
    params: parameter
  })
}

// 短剧列表（搜索）- 列表
export function resellerDrama(parameter) {
  return axios({
    url: BASE_URL + `/reseller/reseller_drama`,
    method: 'get',
    params: parameter
  })
}

// 项目列表（搜索）- 列表
export function resellerProject(parameter) {
  return axios({
    url: BASE_URL + `/reseller/reseller_project`,
    method: 'get',
    params: parameter
  })
}

// 分销商数据 - 列表
export function resellerData(parameter) {
  return axios({
    url: BASE_URL + `/reseller/reseller_data`,
    method: 'get',
    params: parameter
  })
}

// 短剧分销数据 - 列表
export function resellerDramaData(parameter) {
  return axios({
    url: BASE_URL + `/reseller/reseller_drama_data`,
    method: 'get',
    params: parameter
  })
}

// 分销结算单 - 列表
export function resellerCashList(parameter) {
  return axios({
    url: BASE_URL + `/reseller/admin_cash_list`,
    method: 'get',
    params: parameter
  })
}

// 分销结算单 - 详情
export function resellerCashDetail(parameter) {
  return axios({
    url: BASE_URL + `/reseller/admin_cash_detail`,
    method: 'get',
    params: parameter
  })
}

// 分销结算单 - 打款
export function resellerCashPay(parameter) {
  return axios({
    url: BASE_URL + `/reseller/admin_cash_pay`,
    method: 'post',
    data: parameter
  })
}

// iap分销结算单 - 明细数据
export function resellerCashDayDetail(parameter) {
  return axios({
    url: BASE_URL + `/reseller/admin_cash_day_detail`,
    method: 'get',
    params: parameter
  })
}

// iaa分销结算单 - 明细数据
export function iaaResellerCashDayDetail(parameter) {
  return axios({
    url: BASE_URL + `/reseller/admin_iaa_cash_day_detail`,
    method: 'get',
    params: parameter
  })
}

// cpm分销结算单 - 明细数据
export function cpmResellerCashDayDetail(parameter) {
  return axios({
    url: BASE_URL + `/reseller/admin_cpm_cash_day_detail`,
    method: 'get',
    params: parameter
  })
}

// ================================= 《 运营管理 》 

// 快手结算 - 结算列表
export function settlementList(parameter) {
  return axios({
    url: BASE_URL + `/settlement/settlement_list`,
    method: 'get',
    params: parameter
  })
}

// 快手结算 - 结算详情
export function settlementDetail(parameter) {
  return axios({
    url: BASE_URL + `/settlement/settlement_detail`,
    method: 'get',
    params: parameter
  })
}

// 快手结算 - 结算
export function settlement(parameter) {
  return axios({
    url: BASE_URL + `/settlement/settlement`,
    method: 'post',
    data: parameter
  })
}

// 项目列表
export function settlementProjectList(parameter) {
  return axios({
    url: BASE_URL + '/user/project_list',
    method: 'get',
    params: parameter
  })
}

// 抖小达人中介 - 列表
export function dyTaskData(parameter) {
  return axios({
    url: BASE_URL + '/dytask/dy_task_data',
    method: 'get',
    params: parameter
  })
}

// 抖小达人中介 - 中介列表
export function dyAgentName(parameter) {
  return axios({
    url: BASE_URL + '/dytask/agent_name',
    method: 'get',
    params: parameter
  })
}

// 企微列表 - 列表
export function wechatAccountList(parameter) {
  return axios({
    url: BASE_URL + '/wechat/wechat_account_list',
    method: 'get',
    params: parameter
  })
}

// 企微列表 - 新建/编辑
export function wechatAccountSave(parameter) {
  return axios({
    url: BASE_URL + '/wechat/wechat_account_save',
    method: 'post',
    data: parameter
  })
}

// 企微列表 - 删除
export function wechatAccountDelete(parameter) {
  return axios({
    url: BASE_URL + '/wechat/wechat_account_delete',
    method: 'post',
    data: parameter
  })
}

// 微小播放器配置 - 列表
export function wechatConfigList(parameter) {
  return axios({
    url: BASE_URL + '/wechat/config_wechat_list',
    method: 'get',
    params: parameter
  })
}

// 微小播放器配置 - 分享配置
export function wechatShare(parameter) {
  return axios({
    url: BASE_URL + '/wechat/wechat_share',
    method: 'post',
    data: parameter
  })
}

// 微小播放器配置 - 推荐位配置
export function wechatRecPosition(parameter) {
  return axios({
    url: BASE_URL + '/wechat/rec_position',
    method: 'post',
    data: parameter
  })
}

// 微小播放器配置 - 公众号绑定
export function wechatBindAccount(parameter) {
  return axios({
    url: BASE_URL + '/wechat/blind_account',
    method: 'post',
    data: parameter
  })
}

// 微小播放器配置 - 公众号解绑
export function wechatUnbindAccount(parameter) {
  return axios({
    url: BASE_URL + '/wechat/unblind_account',
    method: 'post',
    data: parameter
  })
}

// 播放记录 - 列表
export function videoPlayRecordList(parameter) {
  return axios({
    url: BASE_URL + '/play/video_play_list',
    method: 'get',
    params: parameter
  })
}

// 活动管理 - 列表
export function activityList(parameter) {
  return axios({
    url: BASE_URL + '/activity/list',
    method: 'get',
    params: parameter
  })
}

// 活动管理 - 小程序列表
export function activityProjectAll(parameter) {
  return axios({
    url: BASE_URL + '/activity/project_all',
    method: 'get',
    params: parameter
  })
}

// 活动管理 - 保存
export function activitySave(parameter) {
  return axios({
    url: BASE_URL + '/activity/save',
    method: 'post',
    data: parameter
  })
}

// 视频号挂载数据 - 列表
export function videoFinderList(parameter) {
  return axios({
    url: BASE_URL + '/finder/list',
    method: 'get',
    params: parameter
  })
}

// 视频号挂载数据 - 刷新数据
export function videoFinderRefreshVideoData(parameter) {
  return axios({
    url: BASE_URL + '/finder/refresh_video_data',
    method: 'get',
    params: parameter
  })
}

// 视频号挂载数据 - 获取刷新时间
export function videoFinderRefreshTime(parameter) {
  return axios({
    url: BASE_URL + '/finder/refresh_time',
    method: 'get',
    params: parameter
  })
}

// 内容管理 - 内容聚合页列表
export function aggregationPageList(parameter) {
  return axios({
    url: BASE_URL + '/aggregation/list',
    method: 'get',
    params: parameter
  })
}

// 内容管理 - 内容聚合页保存
export function aggregationPageSave(parameter) {
  return axios({
    url: BASE_URL + '/aggregation/save',
    method: 'post',
    data: parameter
  })
}

// 内容管理 - 榜单页列表
export function rankingList(parameter) {
  return axios({
    url: BASE_URL + '/ranking/list',
    method: 'get',
    params: parameter
  })
}

// 内容管理 - 榜单页保存
export function rankingSave(parameter) {
  return axios({
    url: BASE_URL + '/ranking/save',
    method: 'post',
    data: parameter
  })
}

// 内容管理 - 授权列表
export function aigcList(parameter) {
  return axios({
    url: BASE_URL + '/aigc/list',
    method: 'get',
    params: parameter
  })
}

// 内容管理 - 授权保存
export function aigcSave(parameter) {
  return axios({
    url: BASE_URL + '/aigc/save',
    method: 'post',
    data: parameter
  })
}


// 运营管理 - 充值页列表
export function chargePageList(parameter) {
  return axios({
    url: BASE_URL + '/charge_page/list',
    method: 'get',
    params: parameter
  })
}

// 运营管理 - 充值页保存
export function chargePageSave(parameter) {
  return axios({
    url: BASE_URL + '/charge_page/save',
    method: 'post',
    data: parameter
  })
}


// 运营管理 - 用户投诉列表
export function ComplaintsList(parameter) {
  return axios({
    url: BASE_URL + '/complaints/list',
    method: 'get',
    params: parameter
  })
}

// 运营管理 - 用户投诉状态修改
export function ComplaintsSetStatus(parameter) {
  return axios({
    url: BASE_URL + '/complaints/set_status',
    method: 'post',
    data: parameter
  })
}

// 运营管理 - 星图融合任务
export function dyxtTaskData(parameter) {
  return axios({
    url: BASE_URL + '/dytask/dy_xt_task_data',
    method: 'get',
    params: parameter
  })
}

// 运营管理 - 兑换礼品管理 - 列表
export function giftList(parameter) {
  return axios({
    url: BASE_URL + '/gift/list',
    method: 'get',
    params: parameter
  })
}

// 运营管理 - 兑换礼品管理 - 创建/编辑
export function giftSave(parameter) {
  return axios({
    url: BASE_URL + '/gift/save',
    method: 'post',
    data: parameter
  })
}

// 运营管理 - 兑换礼品管理 - 上下移动
export function giftSort(parameter) {
  return axios({
    url: BASE_URL + '/gift/sort',
    method: 'post',
    data: parameter
  })
}

// 运营管理 - 兑换礼品管理 - 上下架
export function giftStatus(parameter) {
  return axios({
    url: BASE_URL + '/gift/gift_status',
    method: 'post',
    data: parameter
  })
}

// 运营管理 - 礼品兑换 - 列表
export function giftOrderList(parameter) {
  return axios({
    url: BASE_URL + '/gift/order_list',
    method: 'get',
    params: parameter
  })
}

// 运营管理 - 礼品兑换 - 列表
export function giftSaveMsg(parameter) {
  return axios({
    url: BASE_URL + '/gift/save_msg',
    method: 'post',
    data: parameter
  })
}

// ================================= 《 达人运营 》 

// 达人团长结算 - 达人团长列表
export function darenList(parameter) {
  return axios({
    url: BASE_URL + '/dytask/daren_list',
    method: 'get',
    params: parameter
  })
}

// 达人团长结算 - 列表
export function darenSettlementList(parameter) {
  return axios({
    url: BASE_URL + '/dytask/daren_settlement_list',
    method: 'get',
    params: parameter
  })
}

// 达人团长结算 - 生成结算
export function darenSettlement(parameter) {
  return axios({
    url: BASE_URL + '/dytask/daren_settlement',
    method: 'post',
    data: parameter
  })
}

// ================================= 《 抖小播放器配置 》 

// 抖音播放器配置列表
export function ttConfigList(parameter) {
  return axios({
    url: BASE_URL + '/douyin/config_douyin_list',
    method: 'get',
    params: parameter
  })
}

// 抖音播放器-开关配置
export function ttRecPosition(parameter) {
  return axios({
    url: BASE_URL + '/douyin/douyin_rec_position',
    method: 'post',
    data: parameter
  })
}

// ================================= 《 视频号达人库 》 

// 视频号列表——检索
export function finderDarenAll(parameter) {
  return axios({
    url: BASE_URL + '/finder/daren_all',
    method: 'get',
    params: parameter
  })
}

// 服务商列表——检索 type: 0-全部，1-已绑定视频号服务商
export function finderProviderAll(parameter) {
  return axios({
    url: BASE_URL + '/finder/provider_all',
    method: 'get',
    params: parameter
  })
}

// 视频号达人库——列表
export function finderDarenList(parameter) {
  return axios({
    url: BASE_URL + '/finder/daren_list',
    method: 'get',
    params: parameter
  })
}

// 视频号达人库——编辑/创建
export function finderDarenSave(parameter) {
  return axios({
    url: BASE_URL + '/finder/daren_save',
    method: 'post',
    data: parameter
  })
}

// 视频号达人库——服务商列表
export function finderProviderList(parameter) {
  return axios({
    url: BASE_URL + '/finder/provider_list',
    method: 'get',
    params: parameter
  })
}

// 视频号达人库——服务商编辑/创建
export function finderProviderSave(parameter) {
  return axios({
    url: BASE_URL + '/finder/provider_save',
    method: 'post',
    data: parameter
  })
}

// ================================= 《 分类配置 》

// 获取剧情配置列表
export function getAllClassifyList(parameter) {
  return axios({
    url: BASE_URL + '/all_classify_list',
    method: 'get',
    params: parameter
  })
}

// 新增分类配置
export function allClassifyAdd(parameter) {
  return axios({
    url: BASE_URL + `/store/${parameter.source}`,
    method: 'post',
    data: parameter
  })
}

// 更新分类配置
export function allClassifyUpdate(parameter) {
  return axios({
    url: BASE_URL + `/update/${parameter.source}`,
    method: 'post',
    data: parameter
  })
}

// 移动分类配置
export function allClassifySort(parameter) {
  return axios({
    url: BASE_URL + `/sort/${parameter.source}`,
    method: 'post',
    data: parameter
  })
}

// 开关停用分类配置
export function allClassifySwitch(parameter) {
  return axios({
    url: BASE_URL + `/switch/${parameter.source}`,
    method: 'post',
    data: parameter
  })
}

// =================================《 配套设置 》

// 语种管理 - 列表
export function langList(parameter) {
  return axios({
    url: BASE_URL + '/lang/list',
    method: 'get',
    params: parameter
  })
}

// 语种管理 - 列表检索
export function langSearchList(parameter) {
  return axios({
    url: BASE_URL + '/lang/all',
    method: 'get',
    params: parameter
  })
}

// 语种管理 - 新增/编辑
export function langAdd(parameter) {
  return axios({
    url: BASE_URL + '/lang/edit',
    method: 'post',
    data: parameter
  })
}

// 语种管理 - 前台状态
export function langAppStatus(parameter) {
  return axios({
    url: BASE_URL + '/lang/app_status',
    method: 'post',
    data: parameter
  })
}

// 语种管理 - 上下移动
export function langSort(parameter) {
  return axios({
    url: BASE_URL + '/lang/sort',
    method: 'post',
    data: parameter
  })
}

// 商品库 - 列表
export function getgoodList(parameter) {
  return axios({
    url: BASE_URL + '/goods/list',
    method: 'get',
    params: parameter
  })
}

// 商品库 - 检索列表
export function goodAll(parameter) {
  return axios({
    url: BASE_URL + '/goods/all',
    method: 'get',
    params: parameter
  })
}

// 商品库 - 新增/编辑
export function goodsAdd(parameter) {
  return axios({
    url: BASE_URL + '/goods/save',
    method: 'post',
    data: parameter
  })
}

// 自定义充值模板 - 列表
export function udList(parameter) {
  return axios({
    url: BASE_URL + '/charge/ud_list',
    method: 'get',
    params: parameter
  })
}

// 自定义充值模板 - 检索
export function udAll(parameter) {
  return axios({
    url: BASE_URL + '/charge/all',
    method: 'get',
    params: parameter
  })
}

// 自定义充值模板 - 详情
export function udDetail(parameter) {
  return axios({
    url: BASE_URL + `/charge/ud_detail/${parameter.id}`,
    method: 'get',
    params: parameter
  })
}

// 自定义充值模板 - 新增、编辑
export function udSave(parameter) {
  return axios({
    url: BASE_URL + '/charge/ud_save',
    method: 'post',
    data: parameter
  })
}

// 版本策略——列表
export function versionList(parameter) {
  return axios({
    url: BASE_URL + '/lang/version_list',
    method: 'get',
    params: parameter
  })
}

// 版本策略——删除
export function versionDelete(parameter) {
  return axios({
    url: BASE_URL + '/lang/version_delete',
    method: 'post',
    data: parameter
  })
}

// 版本策略——创建/编辑
export function versionSave(parameter) {
  return axios({
    url: BASE_URL + '/lang/version_save',
    method: 'post',
    data: parameter
  })
}

// 版本策略——排序
export function versionSort(parameter) {
  return axios({
    url: BASE_URL + '/lang/version_sort',
    method: 'post',
    data: parameter
  })
}

// 供应商 - 创建/编辑
export function supplierSave(parameter) {
  return axios({
    url: BASE_URL + '/supplier/supplier_save',
    method: 'post',
    data: parameter
  })
}

// 供应商 - 列表
export function supplierList(parameter) {
  return axios({
    url: BASE_URL + '/supplier/supplier_list',
    method: 'get',
    params: parameter
  })
}

// 供应商 - 检索
export function supplierAll(parameter) {
  return axios({
    url: BASE_URL + '/supplier/supplier_all',
    method: 'get',
    params: parameter
  })
}

// =====================================《 用户管理 》

// 用户管理 - 注册用户列表
export function registerList(parameter) {
  return axios({
    url: BASE_URL + '/customer/list',
    method: 'get',
    params: parameter
  })
}

// 用户管理 - 购买记录列表
export function purchaseList(parameter) {
  return axios({
    url: BASE_URL + '/customer/pay_list',
    method: 'get',
    params: parameter
  })
}

// ================================= 《 推广管理 》

// 服务商管理 - 列表
export function serviceProviderList(parameter) {
  return axios({
    url: BASE_URL + '/reseller/list',
    method: 'get',
    params: parameter
  })
}
// 服务商管理 - 创建编辑 
export function serviceProviderSave(parameter) {
  return axios({
    url: BASE_URL + '/reseller/save',
    method: 'post',
    data: parameter
  })
}

// 达人备案 - 列表
export function darenRecordList(parameter) {
  return axios({
    url: BASE_URL + '/reseller/daren_record_list',
    method: 'get',
    params: parameter
  })
}

// 推广链接 - 列表
export function popularizeList(parameter) {
  return axios({
    url: BASE_URL + '/reseller/popularize_list',
    method: 'get',
    params: parameter
  })
}

// 推广链接 - 创建/编辑
export function popularizeDramaSave(parameter) {
  return axios({
    url: BASE_URL + '/reseller/drama_popularize_save',
    method: 'post',
    data: parameter
  })
}

// 服务商 - 检索
export function resellerAll(parameter) {
  return axios({
    url: BASE_URL + '/reseller/all',
    method: 'get',
    params: parameter
  })
}